import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import { TTally } from '../../../models';

interface InvoiceTotalProps {
  total: TTally;
}

function InvoiceTotal({ total }: InvoiceTotalProps) {
  return (
    <div className="flex flex-col gap-3 mt-2">
      <div className="flex">
        <span className="text-text-gray">Subtotal</span>
        <span className="ml-auto">${formatCurrency(total?.subTotal)}</span>
      </div>
      <div className="flex">
        <span className="text-text-gray">Impuestos</span>
        <span className="ml-auto">${formatCurrency(total?.taxTotal)}</span>
      </div>
      {total?.discountTotal > 0 ? (
        <div className="flex">
          <span className="text-text-gray">Descuento</span>
          <span className="ml-auto">
            -${formatCurrency(total.discountTotal)}
          </span>
        </div>
      ) : null}
      <div className="flex mt-2">
        <span className="text-text-black font-semibold">Total</span>
        <span className="ml-auto text-purple-300 font-semibold">
          ${formatCurrency(total?.finalTotal)}
        </span>
      </div>
    </div>
  );
}

export default InvoiceTotal;
